import { SignIn } from "@clerk/clerk-react";
import { useSearchParams } from "react-router-dom";
import { COLORS } from "../hooks/useAudioRecorder";
import { handinvoiceClerkAppearance } from "../utils/clerkAppearance";
import AppFooter from "../components/AppFooter";

export default function SignInPage() {
  const [params] = useSearchParams();
  const redirectUrl = params.get("redirect_url") || "/";
  return (
    <div
      data-testid="sign-in-page"
      style={{
        position: "relative",
        minHeight: "100dvh",
        backgroundColor: COLORS.bg,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px 18px 56px",
      }}
    >
      <SignIn
        routing="path"
        path="/sign-in"
        signUpUrl="/sign-up"
        forceRedirectUrl={redirectUrl}
        fallbackRedirectUrl={redirectUrl}
        appearance={handinvoiceClerkAppearance}
      />
      <AppFooter position="absolute" />
    </div>
  );
}
